import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DropDownItem = ({ icon, text, onClick }) => {
  return (
    <div className="drop-item" onClick={onClick && onClick}>
      <FontAwesomeIcon className="icon" icon={icon} color="#333" size="xs" />
      <p className="text" style={{ textAlign: "left" }}>
        {text}
      </p>
    </div>
  );
};
export default DropDownItem;
